// extracted by mini-css-extract-plugin
module.exports = {"hgroup__heading":"_da","hgroup__subheading":"_db","hgroup":"_dc"};